import HTTP from '@/utils/http-common';
import { encodeOpts } from '@/utils/encode-opts';

const getWalkthroughs = async (query) =>
  (
    await HTTP.get(`/walkthrough`, {
      params: query,
      paramsSerializer: encodeOpts
    })
  ).data;
const getPageWalkthroughs = async (query) =>
  (
    await HTTP.get(`/walkthrough/by-page`, {
      params: query,
      paramsSerializer: encodeOpts
    })
  ).data;
const updateWalkthrough = async (data) => (await HTTP.put(`/walkthrough/${data._id}`, data)).data;
const createWalkthrough = async (data) => (await HTTP.post(`/walkthrough`, data)).data.model;
const deleteWalkthrough = async (walkthroughId) => (await HTTP.delete(`/walkthrough/${walkthroughId}`)).data;
const resetUserWalkthroughs = async (userId) => await HTTP.patch(`/walkthrough/by-user/${userId}/reset`);
const resetStoreWalkthroughs = async (storeId) => await HTTP.patch(`/walkthrough/by-store/${storeId}/reset`);
const resetStorePageWalkthroughs = async (storeId, pageId) =>
  await HTTP.patch(`/walkthrough/by-store/${storeId}/by-page/${pageId}/reset`);

export {
  getWalkthroughs,
  createWalkthrough,
  updateWalkthrough,
  deleteWalkthrough,
  resetUserWalkthroughs,
  getPageWalkthroughs,
  resetStoreWalkthroughs,
  resetStorePageWalkthroughs
};
